<template>
  <notice-dialog
    :show.sync="is_show"
    :title="title"
    :message="content"
    primary-text="關閉"
    primary-type="main-color"
    @primary="onClose"
  />
</template>
<script>
import NoticeDialog from "@/components/dialogs/NoticeDialog.vue";

export default {
  name: 'ErrorDialog',
  components: {
    NoticeDialog,
  },
  data() {
    return {
      is_show: false,
    };
  },
  computed: {
    title() {
      return this.$store.state.error.title || '錯誤';
    },
    is_show_error() {
      return this.$store.state.error.is_show_error;
    },
    content() {
      return this.$store.state.error.message;
    },
  },
  watch: {
    is_show_error(newValue, oldValue) {
      this.is_show = newValue;
    },
    is_show(newValue, oldValue) {
      if (newValue === false) {
        this.$store.dispatch('error/hide');
      }
    },
  },
  methods: {
    onClose() {
      this.is_show = false;
    },
  },
};
</script>
<style>
</style>
